import styled from 'styled-components';
import { LoadingIcon } from "../../Common/Icons";

const LoadingArea = styled.div`
  margin: 0 auto;
  height: 45vh;
  display: flex;
  align-items: center;
  justify-content: center;
  & > svg {
    fill: ${(props) => props.primaryColor};
    width: ${(props) => props.loadingSize};
    height: ${(props) => props.loadingSize};

    circle {
      stroke: ${(props) => props.primaryColor};
    }
  }
`;

function SearchFeedbackLoading({ options = {} }) {
  const commonOptions = {...options};
  const config = Object.entries(options)
    .filter(([option, value]) => value !== undefined)
    .reduce(
      (obj, [option, value]) => {
        obj[option] = value;
        return obj;
      },
      {
        loading_message: `Loading...`,
      }
    );

  return (
    <LoadingArea {...commonOptions.customOptions}>
      {commonOptions.customOptions.customLoader ? <span dangerouslySetInnerHTML={{__html: commonOptions.customOptions.customLoader}} /> : <LoadingIcon /> }
    </LoadingArea>
  );
}

export default SearchFeedbackLoading;
